module.exports = __webpack_public_path__ + "static/media/yx3d11cg51dfxqsk.57c44a06.png";